import { useEffect, useState } from 'react';
import '../styles/modules-scroll-to-top.css';
import { PrototypeIcon } from './PrototypeIcon';

const SCROLL_VISIBILITY_THRESHOLD = 320;

export function ScrollToTopButton(): React.JSX.Element {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const syncVisibility = (): void => {
      setVisible(window.scrollY > SCROLL_VISIBILITY_THRESHOLD);
    };

    syncVisibility();
    window.addEventListener('scroll', syncVisibility, { passive: true });
    return () => window.removeEventListener('scroll', syncVisibility);
  }, []);

  return (
    <button
      className="scroll-to-top"
      type="button"
      hidden={!visible}
      aria-label="Revenir en haut de la page"
      title="Revenir en haut"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <PrototypeIcon name="arrow-up" />
    </button>
  );
}
